
import LazyLoad from 'vanilla-lazyload/dist/lazyload'

// Custom js file from bootstrap
//import 'bootstrap/js/src/index.js'

import  'bootstrap'
import bootbox from 'bootbox'
import Notify from './shared/notify'
import Headroom from 'headroom.js' 
import './newsletter/SaveOrUpdateMemberToNewletter.js';
import RenderForm from './form';

export default function Startup() {

  // Expose some method to call directly in the <script> pages
  window.EntryPoint = {
    SearchPage : () => import('./search'),
    RenderForm :  (id) => RenderForm(id),//(id) => { import('./form').then(({default: RenderForm}) => RenderForm(id)) },
    BindApplauseButton :  (id) => { import('./article/applause').then(({default: BindApplauseButton}) => BindApplauseButton(id)) },
    Notify :  Notify,
    InitForm: (formSelector, callback) => { import('./shared/form').then(({default: InitForm}) => InitForm(formSelector, callback)) },
    InitFormUpload: (formSelector) => { import('./shared/upload').then(({default: InitFormUpload}) => InitFormUpload(formSelector)) }
  };

  //Shrink du header sur le scroll de la page
  ShrinkHeader('.preheader', '.preheader', 'shrinked', 50);

  // Start the lazyload plugin
  let images = document.querySelectorAll("img[data-src]");
  var lazy = new LazyLoad(images);

  $(function () {
    // Dropdown menu toggle
    NavBar();
    // Side menu toggle
    SideBar();
    // Search engine click toggle
    SearchEngine();
    // Loading
    LoadingOnPageChange();
    // Surveyhandling
    Survey();
    //Owl Carousel
    Carousel();
  });

 /**
 * Permet de réduire le header au scroll
 * @param {string} headerSelector selecteur css du header
 * @param {string} shrinkClassName nom de la classe à appliquer au scroll
 * @param {number} scrollTop scroll min au delà duquel on applique la classe
 */
function ShrinkHeader(headerSelector, ElementToHideSelector, shrinkClassName, scrollTop = 300) {
    //On séléctionne le header
    let header = document.querySelector(headerSelector);
    //Si le header existe on ajoute un évènement sur le scroll de la page
  header && document.addEventListener('scroll', throttle(function () {

      //Position en cours du scroll
      let scrollPosition = document.documentElement.scrollTop;
      if (scrollPosition == null || scrollPosition == 0) scrollPosition = document.body.scrollTop;
      let HeightElementToHide = document.querySelector(ElementToHideSelector).clientHeight;
      let subMenu = document.querySelector('.preheader');

      //110 correspond à la hauteur de l'element à cacher
      if (scrollPosition >= scrollTop) {
        //On applique la classe au header
        header.classList.add(shrinkClassName);
        subMenu.style.display = 'none';

      } else {
        //On supprime la classe du header
        header.classList.remove(shrinkClassName);
        // Move stuff
        subMenu.style.display = 'block';
      }

    },50));
  }
  /**
 * Retourne une fonction qui, tant qu'elle est appelée,
 * n'est exécutée au plus qu'une fois toutes les N millisecondes.
 * Paramètres :
 *  - func : la fonction à contrôler
 *  - wait : le nombre de millisecondes (période N) à attendre avant 
 *           de pouvoir exécuter à nouveau la function func()
 *  - leading (optionnel) : Appeler également func() à la première
 *                          invocation (Faux par défaut)
 *  - trailing (optionnel) : Appeler également func() à la dernière
 *                           invocation (Faux par défaut)
 *  - context (optionnel) : le contexte dans lequel appeler func()
 *                          (this par défaut)
 */
  function throttle(func, wait, leading, trailing, context) {
    var ctx, args, result;
    var timeout = null;
    var previous = 0;
    var later = function () {
      previous = new Date;
      timeout = null;
      result = func.apply(ctx, args);
    };
    return function () {
      var now = new Date;
      if (!previous && !leading) previous = now;
      var remaining = wait - (now - previous);
      ctx = context || this;
      args = arguments;
      // Si la période d'attente est écoulée
      if (remaining <= 0) {
        // Réinitialiser les compteurs
        clearTimeout(timeout);
        timeout = null;
        // Enregistrer le moment du dernier appel
        previous = now;
        // Appeler la fonction
        result = func.apply(ctx, args);
      } else if (!timeout && trailing) {
        // Sinon on s’endort pendant le temps restant
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  function LoadingOnPageChange() {
    window.addEventListener('beforeunload', function(e) {
      $('body').addClass('page-loading');
    });
  }

  function SideBar() {

    // Hamburger menu
    $('#sidenav-button').click((e) => {
      $('#sidenav').addClass('sidenav-open');
    });

    // Close button in side bar binding
    $('#sidenav').find('.sidenav-close-button').click((e) => {
      $('#sidenav').removeClass('sidenav-open');
    });

    // Add a handler on the shadow that appear when the sidebar is open
    $('.sidenav-shadow').click((e) => {
      $('#sidenav').removeClass('sidenav-open');
    });
  }

  // Init the navbar
  function NavBar() {

    // grab an element
    var myElement = document.querySelector(".navbar-cip");
    // construct an instance of Headroom, passing the element
    var headroom  = new Headroom(myElement);
    // initialise
    headroom.init(); 

    $('.sidenav-menu').find('.with-childs').children('.nav-link').click(function (e) {
      e.preventDefault();
      let $it = $(this).parent();
      $it.toggleClass('open');
      $('.with-childs.open').not($it[0]).removeClass('open');
      return false;
    }); 
     
    $(document).click((e) => {
      let $elt = $(e.target);
      if (!($elt.closest('.with-childs.open').length)) {
        $('.with-childs.open').removeClass('open');
      }
    });
  }

  function Carousel(){
    if ($('.owl-carousel')[0]){
      $('.owl-carousel').owlCarousel({
        dots: false,
        nav:true,
        responsiveClass:true,
        responsive:{
          0:{
            items:1,
            nav:true
          },
          600:{
            items:2,
            nav:false
          },
          1000:{
            items:3,
            nav:true,
            loop:false
          }
        }});
    }
  }

  function SearchEngine() {
    var $search = $('#search-engine-container');
    var $btnToggle =  $('.btn-search-nav');


    var clickFn = (e) => {
      if ($search.hasClass('active')) {
        $('body').css('overflow-y','auto');
      } else {
        $('body').css('overflow-y','hidden');
      }

      $btnToggle.find('i').toggleClass('zmdi-search');
      $btnToggle.find('i').toggleClass('zmdi-close');
      $search.toggleClass('active');

      setTimeout(function () {
        $('.search-engine-input').focus();
        LoadArticle();
        InitFuzzySearch();
      }, 1000);
    };

    $(document).keyup(function(e) {

      if (e.key === "Escape" && $search.hasClass('active')) { 
        clickFn();
      }
    });

    
    $btnToggle.click(clickFn);
  }




  function InitFuzzySearch(){
    var $containerNews = $('#search-engine-container').find('.search-container-news');
    var $containerResults = $('#search-engine-container').find('.search-container-results');
    var $input =$('#search-engine-container').find('.search-engine-input');
    $input.on('keyup', debounce(function() {
      $containerResults.html('');
      $containerResults.addClass('is-loading');
      var q = $input.val();
      if (q != '' && q.length > 2) {
        $.get('/search/fuzzy?q=' + q, null,{dataType:'json'}).done(function(response){ 
          $containerResults.html('');
          if (response.length == 0) {
            $containerResults.html('<div class="search-result-item" >Aucun résultat</div>');
          }else{
            $.each(response, function(idx,it){
              $containerResults.append('<a class="search-result-item" href="'+it.url+'"><div class="type">'+it.type+'</div><div class="title">'+it.title+'</div><p>'+(it.description != null ? it.description : '')+'</p></a>');
            });
          };
        })
        .always(function(){
          $containerResults.removeClass('is-loading');
        });
      } else{
        $containerResults.removeClass('is-loading');
      } 
    },400))
  }

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  function LoadArticle(){
    var $newsContainer = $('#search-engine-container').find('.search-container-news');
    if ($newsContainer.html() === ''){
      $.get('/article/news', function(data){
        $newsContainer.html(data);
        $newsContainer.find('img').each(function(idx,it){
          lazy.load(it, true);
        })
      })
    }
  }

  function Survey() {
    if ($('.form-survey')[0]) {
      $('.form-survey').find('form').on('submit', function (e) {
        e.preventDefault();

        var $it = $(this);
        var $card = $it.closest('.card');
        $card.addClass('is-loading')
        var id = $it.find('input[name="surveyId"]').val();
        $.post($it.attr('action'), $it.serialize(), function(data){ 
          bootbox.alert('Merci pour votre vote :)');
          $.get('/survey/result/'+id,function(data) {
            $card.replaceWith(data);
          })
        });
        return false;
      })
    }
  }

  /*
  function VideoFullscreen(){
    var iframe = document.querySelector('iframe.video');
    if (document.fullscreenEnabled || 
      document.webkitFullscreenEnabled || 
      document.mozFullScreenEnabled ||
      document.msFullscreenEnabled) {
      
      iframe.addEventListener('click',function() {
        // check if fullscreen mode is available
          // Do fullscreen
          if (iframe.requestFullscreen) {
            iframe.requestFullscreen();
          } else if (iframe.webkitRequestFullscreen) {
            iframe.webkitRequestFullscreen();
          } else if (iframe.mozRequestFullScreen) {
            iframe.mozRequestFullScreen();
          } else if (iframe.msRequestFullscreen) {
            iframe.msRequestFullscreen();
          }
      });
    }
    else {
      console.log('fullscreen not supported')
    }
  }*/

  let startedEvent = new Event('tk-started');

  setTimeout(() => window.dispatchEvent(startedEvent, {bubbles: true}));
}
